import { get, post } from '@/core/h5/request'

export const getEditUrl = fileId => {
    return get({
        url: `/file/api/file/edit/${fileId}`,
        baseURL: process.env.VUE_APP_INTERNET_URL,
        // baseURL: '/resources',
    })
}

export const getPreviewUrl = fileId => {
    return get({
        url: `/file/api/file/preview/${fileId}`,
        baseURL: process.env.VUE_APP_INTERNET_URL,
    })
}

export const getSubPreviewUrl = (subFileId, parentFileId) => {
    return get({
        url: `/file/api/file/preview/sub/${subFileId}?fileId=${parentFileId}`,
        baseURL: process.env.VUE_APP_INTERNET_URL
    });
}

// 推送文档评论
export const postFileComment = data => {
    const options = {
        data,
        url: `/file/api/public/file/comment/notify`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}
